import { createStore } from "@tecreation/js-state"

export const defaultOrderStore = {
	visitorKinds: {},
	products: {},
	errors: [],
	loungers: [],
	timeblock: undefined,
	entryTicket: undefined,
	visitorKindPrice: 0,
	productPrice: 0,
	loungerPrice: 0,
	selectedDay: undefined,
	selectedTb: undefined, //one parent object of the getTimeblocks call
	selectedTbId: undefined, //the real selected timeblockId
	selectTbDeep: undefined, //the real selected timeblock
	selectedTs: undefined, //the selected timeslot
	formattedOrder: undefined,
	objectGroupOptions: [],
	priceActions: [],
	payment: undefined,
	parkingTickets: {},
	addressDetails: {},
	shoppingCart: [],
	thermencardRefillInfo: [],
	massages: [],
	connectedTransponder: undefined,
	availableLoungers: [],
}
export const defaultCoreStore = {
	isLoading: false,
	locale: "de-DE",
	languageCode: "de",
	currency: "EUR",
	locationId: 1,
	location: undefined,
	zoneId: undefined,
	relation: undefined,
	funnel: undefined,
	orderKind: undefined,
	resetPasswordToken: undefined,
	verificationToken: undefined,
	verificationCode: undefined,
	kioskMode: false,
	htgGuestData: undefined,
}

export const appStore = createStore({
	core: defaultCoreStore,
	order: defaultOrderStore,
	errors: [],
})
